import { type ComponentPropsWithoutRef, forwardRef } from 'react'

import { Text } from '@adverity/ds-component/text'

import type { CSSProp, Variant } from '../../types'

type TextOwnProps = ComponentPropsWithoutRef<typeof Text>

type Props = {
    /** sets the color of the text */
    variant?: Variant
    textAlign?: 'left' | 'center' | 'right'
    size?: number | string
    css?: CSSProp
    disabled?: boolean
} & Omit<TextOwnProps, 'color'>

const textColorToVariantMap = {
    success: 'success',
    warning: 'warning',
    danger: 'danger',
} as const

const getColorProps = ({ variant }: { variant?: Variant }) => {
    if (variant) {
        return { color: textColorToVariantMap[variant] }
    }

    return { color: 'secondary' as const }
}

export const HelpText = forwardRef<HTMLElement, Props>((props, ref) => {
    const {
        variant,
        children,
        as,
        textAlign: _textAlign,
        size: sizeIgnored,
        css: cssIgnored,
        disabled: disabledIgnored,
        ...restOfProps
    } = props

    const textAlignClass = _textAlign === 'center' ? 'text-center' : _textAlign === 'right' ? 'text-right' : undefined

    return (
        <Text
            ref={ref}
            as={as}
            textStyle="description"
            className={textAlignClass}
            {...getColorProps({ variant })}
            {...restOfProps}
        >
            {children}
        </Text>
    )
})

HelpText.displayName = 'HelpText'
